export const API_URL_1 = process.env.REACT_APP_BASE_URL;
export const API_URL_4 = 'https://';
